<template>
    <div>
        <TitleBase :data="solveRate">
            <Item v-for="(item, index) in data.solveData" :key="index" :data="item" />
        </TitleBase>
        <TitleBase :data="complaintRate">
            <Item v-for="(item, index) in data.complainData" :key="index" :data="item" />
        </TitleBase>
    </div>
</template>

<script>
import TitleBase from "./TitleBase";
import Item from "./Item";

export default {
    name: "List",
    props: ["data"],
    components: {
        TitleBase,
        Item
    },
    computed: {
        solveRate() {
            return {
                title: this.$t("zhiji.serviceData.solveRate.title"),
                tips: this.$t("zhiji.serviceData.solveRate.tips")
            };
        },
        complaintRate() {
            return {
                title: this.$t("zhiji.serviceData.complaintRate.title"),
                tips: this.$t("zhiji.serviceData.complaintRate.tips")
            };
        }
    }
};
</script>

<style lang="scss" scoped></style>
